export class StretchParam {
    constructor() {
        this.ratio = 0;
        this.priority = 0;
        this.min = 0;
        this.max = 0;
    }
    setRatio(value) {
        this.ratio = value;
        return this;
    }
    setPriority(value) {
        this.priority = value;
        return this;
    }
    setLimit(min, max) {
        this.min = min;
        this.max = max;
        return this;
    }
    setFixed() {
        this.fixed = true;
        return this;
    }
}
